module.exports = __webpack_public_path__ + "img/evaluate_active_3.6f2e9167.png";